interface Props {
  type: 'leaderboard' | 'rectangle' | 'inline';
  className?: string;
}

export default function AdSlot({ type, className }: Props) {
  const cls = {
    leaderboard: 'ad-leaderboard',
    rectangle: 'ad-rectangle',
    inline: 'ad-inline',
  }[type];

  return (
    <div
      className={[cls, className].filter(Boolean).join(' ')}
      aria-label="Advertisement"
      role="complementary"
    />
  );
}
